var swiperOptionsSingle = {
    watchOverflow: true,
    loop: false,
    autoplay: false
};

var swiperOptionsMultiple = {
    speed: 900,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
};

$(function() {

    $document = $(document);

    $document.foundation();

    $(document).on('open.zf.reveal', '[data-reveal]', function () {
      $(this).addClass("opened");
    });

    $(document).on('closed.zf.reveal', '[data-reveal]', function () {
      $(this).removeClass("opened");
    });

    // lightbox overlay trigger

    $document.on('click', 'a.lightbox', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var filename = url.split('.').pop().toLowerCase();
            var imgclass = 'img-fluid';
            if (filename === 'svg') {
                imgclass += ' img-vector';
            }
            $('#overlayPreviewContent').css('background-image','url("'+url+'")');
            $('#overlayPreview').foundation('open');
        }
    });

    // share overlay trigger

    $document.on('click', '.sharePopup a', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var newWindow = window.open(url, 'Share', 'scrollbars=yes, width=1024, height=660');
            if (window.focus) {
                newWindow.focus();
            }
        }
    });

    // share buttons trigger

    $document.on('click', '.panelShare', function(e) {
        e.preventDefault();
        $('#panelShareLinks').toggleClass('hide');
    });

    // scroll to anchor

    $document.on('click', '#main a[href^="#"]', function(e) {
        if (!$(this).hasClass('noanchor')) {
            var id = $(this).attr('href');
            var $id = $(id);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            var pos = $id.offset().top;
            var offset = $('#header').outerHeight()+30;
            $('body, html').animate({scrollTop: pos-offset}, 600);
        }
    });

    // directory list

    $document.on('click', '#buttonDirectoryList', function(e) {
        e.preventDefault();
        $('#buttonDirectoryList').removeClass('hollow');
        $('#buttonDirectoryMap').addClass('hollow');
        $('#directoryMap').fadeOut(function() {
            $('#directoryList').fadeIn();
        });
    });

    // directory map

    $document.on('click', '#buttonDirectoryMap', function(e) {
        e.preventDefault();
        $('#buttonDirectoryMap').removeClass('hollow');
        $('#buttonDirectoryList').addClass('hollow');
        $('#directoryList').fadeOut(function() {
            $('#directoryMap').fadeIn();
        });
    });


//    AOS.init();

});
